var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.visible)?_c('SpecImageChoose',{attrs:{"title":_vm.$l('dialog_title_skuImage') || '选择产品图片',"visible":"","evgSkuCode":_vm.evgSkuCode},on:{"setImage":_vm.setImage,"close":_vm.close}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }